import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'language';

export function readStoredLanguage() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'he' ? 'he' : 'en';
  } catch (e) {
    return 'en';
  }
}

export function applyDocumentLanguage(lang) {
  const root = document.documentElement;
  root.lang = lang;
  root.dir = lang === 'he' ? 'rtl' : 'ltr';
}

// One place for language state: components read `isHe` and call `setLang`
// instead of keeping their own copies in local state.
export default function useLang() {
  const { t, i18n } = useTranslation('global');
  const lang = i18n.language === 'he' ? 'he' : 'en';

  const setLang = (next) => {
    i18n.changeLanguage(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      // Storage can be unavailable (private mode); the choice still applies for this visit.
    }
  };

  return { t, i18n, lang, isHe: lang === 'he', setLang };
}
